import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import bindMethods from 'auto-bind';

import { getGroups } from '../state/groups';
import { setGroup } from '../state/navigationSelection';
import { resetTeamsData } from '../state/teams';
import { resetSeasonsData } from '../state/seasons';
import { resetGamesData } from '../state/games';
import { disableToggle } from '../state/sidebar';
import { resetTeamSeasonGameSelection } from '../state/teamSeasonGameSelection';
import { generateGroupOptions } from '../utils/generateNavigationOptions';
import { getGroupValue } from '../state/selectors/getNavigationValue';
import NavigationItemPicker from './NavigationItemPicker';

class GroupsPicker extends PureComponent {
  constructor(props) {
    super(props);
    bindMethods(this);
  }

  componentDidMount() {
    const { isLoaded, getGroups } = this.props;

    if (!isLoaded) {
      getGroups();
    }
  }

  generateOptions() {
    const { groups } = this.props;
    const options = generateGroupOptions(groups);
    return options;
  }

  selectGroup(groupId) {
    const { getGroupValue, setGroup } = this.props;
    const value = getGroupValue;

    if (groupId === value.value) {
      return;
    }

    const {
      groups,
      resetTeamsData,
      resetSeasonsData,
      resetGamesData,
      resetTeamSeasonGameSelection,
      disableToggle,
    } = this.props;
    const group = groups.find(group => group.groupId === groupId);

    setGroup(group);
    resetTeamsData();
    resetSeasonsData();
    resetGamesData();
    resetTeamSeasonGameSelection();
    disableToggle();
  }

  handleChange(value) {
    this.selectGroup(value.value);
  }

  render() {
    const { isLoaded } = this.props;

    if (!isLoaded) {
      return null;
    }

    const { t, getGroupValue } = this.props;

    return (
      <NavigationItemPicker
        selectId="NavigationBar.DropDown.Group"
        value={getGroupValue}
        options={this.generateOptions()}
        theme="general"
        onChange={this.handleChange}
        placeholder={t('NavigationBar.Placeholders.Group')}
      />
    );
  }
}

GroupsPicker.propTypes = {
  t: PropTypes.func.isRequired,
  isLoaded: PropTypes.bool.isRequired,
  groups: PropTypes.array.isRequired,
  getGroups: PropTypes.func.isRequired,
  setGroup: PropTypes.func.isRequired,
  getGroupValue: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  resetTeamsData: PropTypes.func.isRequired, // supplied from Redux
  resetSeasonsData: PropTypes.func.isRequired, // supplied from Redux
  resetGamesData: PropTypes.func.isRequired, // supplied from Redux
  resetTeamSeasonGameSelection: PropTypes.func.isRequired, // supplied from Redux
  disableToggle: PropTypes.func.isRequired, // supplied from Redux
};

const mapStateToProps = state => ({
  isLoaded: state.groups.isLoaded,
  groups: state.groups.groups,
  getGroupValue: getGroupValue(state),
});

const mapDispatchToProps = {
  getGroups,
  setGroup,
  resetTeamsData,
  resetSeasonsData,
  resetGamesData,
  resetTeamSeasonGameSelection,
  disableToggle,
};

const TranslatedComponent = withTranslation()(GroupsPicker);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TranslatedComponent);
